
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://pmgxxdygiumlbodjnuqw.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InBtZ3h4ZHlnaXVtbGJvZGpudXF3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDc1NDEyNTYsImV4cCI6MjA2MzExNzI1Nn0.Li2I79ZEbTylj0qnei5E8-oNAPtiHQBltEVVWZJ8YPI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});
